import { z } from 'zod';

/**
 * A subset of our usual collection of business attributes, relevant to speaker selection.
 */
export const SpeakerSelectionBusinessInfoSchema = z.object({
  name: z.string().nullish(),
  city: z.string().nullish(),
  state: z.string().nullish(),
  countryCode: z.string().nullish(),
  description: z.string().nullish(),
  industry: z.string().nullish(),
  websiteURL: z.string().nullish(),
});
export type BusinessInfo = z.infer<typeof SpeakerSelectionBusinessInfoSchema>;

export const SpeakerSelectionRequestSchema = z.object({
  businessInfo: SpeakerSelectionBusinessInfoSchema,
  instructions: z.string().nullish(),
  vibe: z.string().nullish(),
  text: z.string().nullish(),
  languageCode: z.string().nullish(),
  duration: z.number(),
});
export type SpeakerSelectionRequest = z.infer<typeof SpeakerSelectionRequestSchema>;

export const LanguageDeterminationSchema = z.object({
  explanation: z.string(),
  languageCode: z.string(),
});
export type LanguageDetermination = z.infer<typeof LanguageDeterminationSchema>;

export enum Timbre {
  Feminine = 'Feminine',
  Masculine = 'Masculine',
  Neuter = 'Neutral',
}

export const TimbreDeterminationSchema = z.object({
  explanation: z.string(),
  timbre: z.nativeEnum(Timbre),
});
export type TimbreDetermination = z.infer<typeof TimbreDeterminationSchema>;
